//MUI components
import { Box, Typography } from "@mui/material";

//images
import mantenimiento from "../../assets/images/servicios/mantenimiento.png";
import supervision from "../../assets/images/servicios/montaje.png";
import montaje from "../../assets/images/servicios/supervision.png";
import postventa from "../../assets/images/servicios/postventa.png";

//My Components
import { Header } from "../../components/header";
import { Footer } from "../../components/footer";
import ProductsCard from "../../components/card";

import { useTranslation } from "react-i18next";

function Servicios() {

  const { t } = useTranslation();

  return (
    <>
      <div
        style={{
          position: "relative",
          minHeight: "10dvh",
          overflowX: "hidden",
          background: "#FFF",
        }}
      >
        <Header color={"#F0F0F0"} />
        <Box
          sx={{
            marginTop: "10rem",
            marginBottom: "2rem",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Typography
            style={{
              color: "#1B2466",
              fontFamily: "Montserrat",
              fontSize: "50px",
              fontStyle: "normal",
              fontWeight: "800",
              lineHeight: "52%",
              textAlign: "center",
              letterSpacing: "-0.1px",
            }}
          >
            {t("nuestros_servicios_titulo")}
          </Typography>
          <Box sx={{ marginTop: "1rem" }}>
            <Typography
              style={{
                color: "#6EB1D9",
                textAlign: "center",
                fontFamily: "Montserrat",
                fontSize: "29px",
                fontStyle: "normal",
                fontWeight: "800",
                lineHeight: "100%",
              }}
            >
              {t("nuestros_servicios_subtitulo")}
            </Typography>
          </Box>
          <Box sx={{ marginTop: ".75rem", width: "50%" }}>
            <Typography
              style={{
                color: "#1B2466",
                textAlign: "center",
                fontFamily: "Montserrat",
                fontSize: "17px",
                fontStyle: "normal",
                fontWeight: "400",
                lineHeight: "120%",
              }}
            >
              {t("nuestros_servicios_parrafo")}
            </Typography>
          </Box>
        </Box>
      </div>

      {/* Tarjetas */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          flexWrap: "wrap",
          gap: "3rem",
          marginTop: "2rem",
        }}
      >
        <ProductsCard
          image={mantenimiento}
          text={t("nuestros_servicios_item1")}
          width={"22.5rem"}
          height={"46.25rem"}
          backgroundColor={"#F0F0F0"}
          textColor={"#1B2466"}
          position={"relative"}
          text2={
            t("nuestros_servicios_item1_parrafo")
          }
          paddingY={8}
          paddingX={8}
        />

        <ProductsCard
          image={supervision}
          text={t("nuestros_servicios_item2")}
          width={"22.5rem"}
          height={"46.25rem"}
          backgroundColor={"#F0F0F0"}
          textColor={"#1B2466"}
          position={"relative"}
          text2={
            t("nuestros_servicios_item2_parrafo")
          }
          paddingY={8}
          paddingX={8}
        />

        <ProductsCard
          image={montaje}
          text={t("nuestros_servicios_item3")}
          width={"22.5rem"}
          height={"46.25rem"}
          backgroundColor={"#F0F0F0"}
          textColor={"#1B2466"}
          position={"relative"}
          text2={
            t("nuestros_servicios_item3_parrafo")
          }
          paddingY={8}
          paddingX={8}
        />

        <ProductsCard
          image={postventa}
          text={t("nuestros_servicios_item4")}
          width={"22.5rem"}
          height={"46.25rem"}
          backgroundColor={"#F0F0F0"}
          textColor={"#1B2466"}
          position={"relative"}
          text2={t("nuestros_servicios_item4_parrafo")}
          paddingY={8}
          paddingX={8}
        />
      </Box>

      <Box sx={{ marginTop: "5rem" }}>
        <Footer />
      </Box>
    </>
  );
}

export default Servicios;
